import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import api from '../services/api';
import { extractFieldErrors } from '../utils/formErrorUtils';

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';


const Login = () => {
  const { login } = useContext(AuthContext);
  const [username, setUsername] = useState('denizalp.ozalp@mindtech.com.tr');
  const [password, setPassword] = useState('admin');
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    const errs = {};
    if (!username) errs.username = 'Email gerekli';
    if (!password) errs.password = 'Şifre gerekli';
    if (Object.keys(errs).length) {
      setFieldErrors(errs);
      return;
    }
    try {
      setError('');
      setFieldErrors({});
      const response = await api.post(
        '/auth/login',
        new URLSearchParams({
          username,
          password,
          grant_type: 'password',
        }),
        {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          skipGlobal401Handler: true,
        }
      );

      const { access_token } = response.data;
      await login(access_token);
      navigate('/');
    } catch (err) {
      if (err?.response?.status === 422) {
        const serverErrors = {};
        extractFieldErrors(err).forEach(({ field, message }) => {
          serverErrors[field] = message;
        });
        setFieldErrors(serverErrors);
      } else if (err?.config?.url?.includes('/users/me')) {
        setError('Kullanıcı bilgileri alınırken bir hata oluştu. Lütfen daha sonra tekrar deneyin.');
      } else if (err?.response?.status === 401) {
        setError('Email veya şifre hatalı.');
      } else if (err?.response?.status >= 500) {
        setError('Sunucu hatası. Lütfen daha sonra tekrar deneyin.');
      } else {
        setError('Giriş başarısız.');
      }
    }
  };

  return (
    <div className="flex align-items-center justify-content-center min-h-screen bg-gray-100">
      <Card title="Giriş Yap" className="w-full sm:w-20rem shadow-2">
        <form onSubmit={handleLogin} className="flex flex-column gap-3">
          <div className="p-float-label">
            <InputText
              id="username"
              value={username}
              onChange={(e) => { setUsername(e.target.value); setFieldErrors((f)=>({...f, username: undefined})); }}
              className={`w-full ${fieldErrors.username ? 'p-invalid' : ''}`}
            />
            <label htmlFor="username">Email</label>
            {fieldErrors.username && <small className="p-error">{fieldErrors.username}</small>}
          </div>

          <div className="p-float-label">
            <Password
              id="password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setFieldErrors((f)=>({...f, password: undefined})); }}
              toggleMask
              className={`w-full ${fieldErrors.password ? 'p-invalid' : ''}`}
              feedback={false}
            />
            <label htmlFor="password">Şifre</label>
            {fieldErrors.password && <small className="p-error">{fieldErrors.password}</small>}
          </div>

          {error && <small className="text-red-500">{error}</small>}

          <Button label="Giriş Yap" type="submit" className="w-full" />
        </form>
      </Card>
    </div>
  );
};

export default Login;
